interface ProcessingPanelProps {
  label: string;
  elapsedMs: number;
  visible: boolean;
  progress?: number;
}

export function ProcessingPanel({
  label,
  elapsedMs,
  visible,
  progress = 0,
}: ProcessingPanelProps) {
  if (!visible) return null;
  const seconds = (elapsedMs / 1000).toFixed(1);
  const pct = Math.round(Math.min(100, Math.max(0, progress)));

  return (
    <div className="absolute inset-0 z-20 flex flex-col justify-end border-[3px] border-ink bg-crate/95 p-6 text-cream">
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-acid">
        Press running
      </p>
      <p className="mt-2 font-slam text-5xl uppercase leading-none">{pct}%</p>
      <p className="mt-3 text-sm">{label}</p>
      <div className="mt-4 h-4 border-[3px] border-cream">
        <div className="h-full bg-acid" style={{ width: `${Math.max(4, pct)}%` }} />
      </div>
      <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.16em] text-cream/60">
        {seconds}s on this machine
      </p>
    </div>
  );
}
